import { observable, action, flow, computed } from 'mobx';
import Stores from 'config/Stores';
import { Toast, Modal } from 'antd-mobile';
import Config from 'config/Config';
import Util from 'utils';
import Serv from './AIImageTextServ';

class AIImageTextMod {
  // 图文详情
  @observable detailData = {};
  // 图文图片列表
  @observable imageList = [];

  @observable shareImgSrc = [];

  /**
   * 更改状态
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  getWordImageDetail = flow(function* (id) {
    try {
      const { resultCode, data } = yield Serv.getWordImageDetail(id);
      console.log('datadatadata', data);
      if (`${resultCode}` === '0') {
        this.detailData = data || {};
        this.imageList = (data.imageList || []).map((val) => val.imageUrl);
      }
    } catch (error) {
      console.log('getWordImageDetail err', error);
    }
  });
}

export default AIImageTextMod;



// WEBPACK FOOTER //
// ./src/pages/AICreation/AIImageText/AIImageTextMod.js